import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import Bannerimg01 from '../../../assets/images/about/banner-five-call.svg';
import Bannerimg02 from '../../../assets/images/about/banner-five-1.jpg';
import Bannerimg03 from '../../../assets/images/about/banner-five-2.jpg';

const Banner = () => {
    const BannerSlider = {
        dots: true,
        infinite: true,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 6000,
        slidesToShow: 1,
        fade: true,
        cssEase: 'ease',
        arrows: false,
        slidesToScroll: 1
    };
    return (
        <>
            <div className="banner-section-five">
                <div className="container">
                    <div className="row align-items-center banner-upper-five gutter-y-30">
                        <div className="col-lg-6">
                            <div
                                className="banner-five-heading animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                            >
                                <h1>Empower your business to the Next level</h1>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div
                                className="banner-heading-details-five animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <p className="lead">
                                    At Uniqo, we are a renowned global consulting firm committed to
                                    collaborating with business and societal leaders in overcoming their
                                    most critical challenges and seizing their greatest opportunities.
                                </p>
                                <div className="banner-button-five">
                                    <Link to="/Aboutus" className="btn btn-dark btn-theme">
                                        View more <span>+</span>
                                    </Link>
                                    <div className="banner-call-action-five">
                                        <span>
                                            <img
                                                src={Bannerimg01}
                                                alt="icon"
                                            />
                                        </span>
                                        <div className="banner-call-five">
                                            <span>Have a any Questions ?</span>
                                            <Link to="telto:(234)109-6666">(234)109-6666</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="banner-slider-outer-five">
                    <Slider className="banner-section-five" {...BannerSlider}>
                        <div className="banner-slider-item">
                            <div className="banner-slider-image-five">
                                <img src={Bannerimg02} alt="banner-image" />
                            </div>
                        </div>
                        <div className="banner-slider-item">
                            <div className="banner-slider-image-five">
                                <img src={Bannerimg03} alt="banner-image" />
                            </div>
                        </div>
                        <div className="banner-slider-item">
                            <div className="banner-slider-image-five">
                                <img src={Bannerimg02} alt="banner-image" />
                            </div>
                        </div>
                        <div className="banner-slider-item">
                            <div className="banner-slider-image-five">
                                <img src={Bannerimg03} alt="banner-image" />
                            </div>
                        </div>
                    </Slider>
                    <div id="slider-info-2" />
                </div>
                <div className="container-fluid">
                    <div className="row banner-box-outer-five">
                        <div className="col-lg-4 col-md-6">
                            <div className="banner-box-five">
                                <div className="banner-box-icon-five">
                                    <svg
                                        width={73}
                                        height={73}
                                        viewBox="0 0 73 73"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M36.2539 50.9375V71.5"
                                            stroke="#3B4443"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M5.72265 18.625C1.84288 25.345 0.288841 33.1573 1.30155 40.8505C2.31426 48.5437 5.83712 55.6878 11.3238 61.1748C16.8105 66.6618 23.9543 70.1851 31.6474 71.1982C39.3405 72.2114 47.153 70.6578 53.8732 66.7785C60.5934 62.8991 65.8458 56.9107 68.8158 49.742C71.7858 42.5734 72.3074 34.625 70.2998 27.1297C68.2921 19.6344 63.8674 13.0109 57.7118 8.28656C51.5563 3.56219 44.0138 1.00093 36.2543 1V21.5625C39.4874 21.5632 42.6299 22.6307 45.1945 24.5994C47.7591 26.5681 49.6024 29.3279 50.4387 32.451C51.2749 35.574 51.0574 38.8858 49.8197 41.8726C48.582 44.8594 46.3934 47.3544 43.5933 48.9706C40.7932 50.5868 37.5381 51.234 34.3327 50.8117C31.1273 50.3894 28.1508 48.9213 25.8648 46.6351C23.5788 44.3488 22.111 41.3721 21.6891 38.1667C21.2672 34.9613 21.9147 31.7062 23.5312 28.9063L5.72265 18.625Z"
                                            stroke="#3B4443"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M22.0621 40.0542L2.19727 45.3747"
                                            stroke="#3B4443"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <div className="banner-box-details-five">
                                    <h4>Project Analysis</h4>
                                    <p className="lead">
                                        Research &amp; development in project analysis sector of a company
                                        represents its strengthfinding a solution.
                                    </p>
                                    <Link to="/ServiceDetails" className="banner-btn-five">
                                        <span>Read More</span>+
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="banner-box-five">
                                <div className="banner-box-icon-five">
                                    <svg
                                        width={83}
                                        height={64}
                                        viewBox="0 0 83 64"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M60.875 32C63.1532 32 65 30.1532 65 27.875C65 25.5968 63.1532 23.75 60.875 23.75C58.5968 23.75 56.75 25.5968 56.75 27.875C56.75 30.1532 58.5968 32 60.875 32Z"
                                            fill="#3B4443"
                                        />
                                        <path
                                            d="M37.5 12.75H51.25"
                                            stroke="#3B4443"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M73.25 1.75H48.5"
                                            stroke="#3B4443"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M1.75 37.5C1.75 35.312 2.61919 33.2135 4.16637 31.6664C5.71354 30.1192 7.81196 29.25 10 29.25"
                                            stroke="#3B4443"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M74.7419 21H76C77.4587 21 78.8577 21.5795 79.8891 22.6109C80.9206 23.6424 81.5 25.0413 81.5 26.5V37.5C81.5 38.9587 80.9206 40.3576 79.8891 41.3891C78.8577 42.4205 77.4587 43 76 43H73.25L67.0281 60.4247C66.8373 60.9592 66.4857 61.4216 66.0217 61.7484C65.5576 62.0752 65.0038 62.2504 64.4363 62.25H60.0638C59.4962 62.2504 58.9424 62.0752 58.4783 61.7484C58.0143 61.4216 57.6627 60.9592 57.4719 60.4247L56.1622 56.75H32.5878L31.2781 60.4247C31.0873 60.9592 30.7357 61.4216 30.2717 61.7484C29.8076 62.0752 29.2538 62.2504 28.6863 62.25H24.3138C23.7462 62.2504 23.1924 62.0752 22.7283 61.7484C22.2643 61.4216 21.9127 60.9592 21.7219 60.4247L17.2188 47.8125C12.569 42.7497 9.99235 36.124 10 29.25C10 21.9565 12.8973 14.9618 18.0546 9.80456C23.2118 4.64731 30.2066 1.75 37.5 1.75H48.5C53.8663 1.74845 59.1157 3.31697 63.6015 6.26227C68.0873 9.20757 71.6133 13.401 73.745 18.3256C74.1221 19.1997 74.4549 20.0923 74.7419 21Z"
                                            stroke="#3B4443"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <div className="banner-box-details-five">
                                    <h4>Investment Analysis</h4>
                                    <p className="lead">
                                        We approach every client relationship with a unique and
                                        invigorating perspective, coupled with an unwavering energy.
                                    </p>
                                    <Link to="/ServiceDetails" className="banner-btn-five">
                                        <span>Read More</span>+
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="banner-box-five">
                                <div className="banner-box-icon-five">
                                    <svg
                                        width={68}
                                        height={68}
                                        viewBox="0 0 68 68"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M34 67C52.2254 67 67 52.2254 67 34C67 15.7746 52.2254 1 34 1C15.7746 1 1 15.7746 1 34C1 52.2254 15.7746 67 34 67Z"
                                            stroke="#3B4443"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M47.75 34C47.75 56 34 67 34 67C34 67 20.25 56 20.25 34C20.25 12 34 1 34 1C34 1 47.75 12 47.75 34Z"
                                            stroke="#3B4443"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M2.87695 23H65.1232"
                                            stroke="#3B4443"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M2.87695 45H65.1232"
                                            stroke="#3B4443"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>
                                <div className="banner-box-details-five">
                                    <h4>Global Operation</h4>
                                    <p className="lead">
                                        We approach every client relationship with a unique and
                                        invigorating perspective, coupled with an unwavering energy.
                                    </p>
                                    <Link to="/ServiceDetails" className="banner-btn-five">
                                        <span>Read More</span>+
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Banner;
